// 🐛 ENCUENTRA EL ERROR — Parte II §0 y §2 del documento maestro.
//
// Spec visual del documento:
//   · "Frase renderizada como palabras individuales tocables (<span> con
//      hover/tap state)."
//   · "Al tocar la palabra correcta (el error), esa palabra se tacha con una
//      línea animada y aparece la corrección en verde arriba, con una
//      transición tipo 'flip card'."
//   · "Si toca la palabra equivocada, esa palabra tiembla suavemente (no
//      bloquea el intento, permite reintentar)."
//
// ⚠️ El documento permite reintentar. Para que el scoring siga siendo honesto,
//    el acierto se registra solo si encuentra el error al PRIMER toque: quien
//    lo halla por descarte no demuestra la misma atención gramatical fina que
//    el formato dice medir. Los reintentos siguen siendo libres y sin castigo
//    visual — el alumno nunca queda bloqueado.
import { useState } from 'react';

export default function SlideEncuentraError({ slide, onAnswer, locked }) {
  const [wrongIdx, setWrongIdx] = useState(null);
  const [found, setFound] = useState(false);
  const [attempts, setAttempts] = useState(0);

  const handleWord = (i) => {
    if (found || locked) return;

    if (i === slide.wrongIndex) {
      setFound(true);
      onAnswer(attempts === 0);   // acierto solo al primer toque
      return;
    }

    setAttempts((a) => a + 1);
    setWrongIdx(i);
    setTimeout(() => setWrongIdx(null), 500);
  };

  return (
    <>
      <p className="ob-subhead">Toca la palabra que está mal:</p>

      <div className="ob-error-sentence">
        {slide.words.map((w, i) => {
          let cls = 'ob-word';
          if (found && i === slide.wrongIndex) cls += ' ob-word-found';
          if (wrongIdx === i) cls += ' ob-word-wrong';
          return (
            <button
              key={`${slide.id}-w-${i}`}
              type="button"
              className={cls}
              onClick={() => handleWord(i)}
              disabled={found || locked}
            >
              {w}
            </button>
          );
        })}
      </div>

      {found && (
        <div className="ob-correction">
          <span aria-hidden="true">→</span>
          <span>{slide.correction}</span>
        </div>
      )}
    </>
  );
}
